export default __webpack_public_path__ + "static/media/Rectangle.acfd68ec.png";